import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_MODIFIER_CODE_REQUEST: '',
  GET_MODIFIER_CODE_SUCCESS: '',
  GET_MODIFIER_CODE_FAILURE: '',

};

types = setStoreTypeValues(types, 'authModifierCode');

export default types;
